import { NEW_CREDIT_ID_START, NEW_CREDIT_ID_SUCCESS, NEW_CREDIT_ID_FAIL } from '../actions/ActionsTypes';

const initialState = {
    success: false,
    error: null,
    loading: false,
};


export default function (state = initialState, action) {
    switch (action.type) {
        case NEW_CREDIT_ID_START:
            return {
                ...state,
                loading: true,
                error: false
            }
        case NEW_CREDIT_ID_SUCCESS:
            return {
                ...state,
                success: true,
                error: null,
                loading: false
            }
        case NEW_CREDIT_ID_FAIL:
            return {
                ...state,
                success: false,
                error: true,
                loading: false,
            }
        default:
            return state;
    }
}